import React, {useEffect, useRef, useState} from 'react';
import cn from 'classnames';

import {useDebouncedCallback} from 'coreHooks';

import CarouselModuleBody from '../CarouselModule/CarouselModuleBody/CarouselModuleBody';
import {ModuleMedia, ModuleText} from '../Common';

import {IImageCarousel} from './IImageCarousel';

import styles from './ImageCarousel.module.scss';

const ImageCarousel = (props: IImageCarousel) => {
	const {title, body, textColorVariant, backgroundColor, variant, productIds} = props;
	const contentBackground = backgroundColor === 'grey' ? '#F9F9F9' : '#ffffff';
	const [titleHeight, setTitleHeight] = useState(0);
	const titleRef = useRef<HTMLDivElement>(null);
	const carouselStyle = {
		'--display-pagination-desktop': body?.[0]?.props?.children?.length > 4 ? 'block' : 'none',
		'--pagination-color': body?.[0].props?.paginationColor || '#000000',
		'--content-background-color': contentBackground,
		'--carousel-title-height': `${titleHeight}px`,
	} as React.CSSProperties;
	const CarouselBody = body[1];

	const updateTitleHeight = () => {
		if (titleRef.current) {
			setTitleHeight(titleRef.current.offsetHeight);
		}
	};

	const debouncedUpdateTitleHeight = useDebouncedCallback(updateTitleHeight, 200);

	useEffect(() => {
		updateTitleHeight(); // Calculate the height initially
		window.addEventListener('resize', debouncedUpdateTitleHeight);

		return () => {
			window.removeEventListener('resize', debouncedUpdateTitleHeight);
			debouncedUpdateTitleHeight.cancel();
		};
	}, [title]);

	return (
		<div className={styles['module-image_carousel']}>
			<div className={styles['module-image_carousel__content']}>
				<ModuleMedia classNames={styles['module-image_carousel__media']}>{body[0]}</ModuleMedia>
				<div
					className={cn(styles['module-image_carousel__carousel'], {[styles[`${variant}`]]: variant})}
					style={carouselStyle}
				>
					<div ref={titleRef} className={styles['module-image_carousel__title']}>
						{title && (
							<ModuleText contentfulField="title" colorVariant={textColorVariant} text={title} />
						)}
					</div>
					<div className={styles['module-image_carousel__body']}>
						{productIds && <CarouselModuleBody body={CarouselBody} productIds={productIds} />}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ImageCarousel;
